import { useState, useEffect, useCallback } from 'react';

export function useGlobalSearch() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const closeSearch = useCallback(() => {
    setIsSearchOpen(false);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check for Ctrl+Space keyboard combination
      if (e.ctrlKey && e.code === 'Space') {
        e.preventDefault(); // Prevent default browser behavior
        setIsSearchOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return { isSearchOpen, closeSearch };
} 